<template lang="pug">
v-breadcrumbs.pt-0(:items='breadcrumbs' v-if='breadcrumbs')
  v-icon(slot='divider' color='grey') chevron_right
  template(slot='item' slot-scope='props')
    v-menu(v-model='props.item.isMenuShow' :disabled='props.item.disabled')
      a(slot='activator' :class="[props.item.disabled && 'v-breadcrumbs__item--disabled']")
        v-icon(v-if='props.item.icon' small) {{ props.item.icon }}
        span(v-else) {{ props.item.text }}
      v-card
        v-list
          v-list-tile(v-for='(i, index) in props.item.menu' :to='i.to || false' :key='index')
            v-list-tile-title {{ i.text }}
</template>

<script>
export default {
  name: 'LotteryBreadcrumb',
  computed: {
    period () {
      return parseInt(this.$route.params.period)
    },
    breadcrumbs () {
      const period = this.period
      const lotteryItems = this.lotteryItems || []

      if (period === undefined) return null

      const periodMenu = lotteryItems.map(v => {
        return {
          text: `${v} 屆`, // 選單項目文字
          to: { name: 'lottery', params: { period: v } },
        }
      })

      return [
        { text: '抽獎', icon: 'fas fa-ticket-alt', disabled: true },
        { text: `${period} 屆`, menu: periodMenu },
      ]
    },
    lotteryInfo () {
      return this.$store.state.lotteryInfo
    },
    lotteryItems () {
      if (!this.lotteryInfo) return []
      const list = [...this.lotteryInfo]
      list.sort((a, b) => b - a)
      return list
    },
  },
}
</script>

<style scoped lang="sass">

</style>
